<p-dialog
	[(visible)]="this.isVisible"
	[autoZIndex]="true"
	[baseZIndex]="90000"
	[closable]="true"
	[modal]="true"
	[style]="{ width: '60rem' }"
	(onHide)="close()"
>
	<ng-template pTemplate="header">
		<div class="dialog-header">
			<strong>Welcome to Tyalls, {{ this.currentUser?.firstName }}!</strong>
		</div>
	</ng-template>
	<div class="setup-dialog">
		<!-- LEFT SIDE -->
		<div class="setup-left">
			<p class="intro-text">
				Let's get your account set up—this takes less than a minute.
			</p>

			<p class="choose-text">Choose your preferred method below:</p>

			<!-- PRE-CONFIGURED SECTION -->
			<div class="section pre-configured">
				<div class="section-header">
					<span class="title">Pre-Configured Setup</span>
					<span class="badge recommended">Recommended</span>
					<span class="badge fast-start">Fast Start</span>
				</div>
				<p class="section-subtext">
					Start with {{ this.orgTaskTemplates?.length }} ready-to-go tasks. Customise, add, or remove tasks at any
					time.
				</p>
				<p class="section-note">
					Note: AI availability depends on your PMS selection.
				</p>
				<ul class="task-list">
					<li *ngFor="let task of this.orgTaskTemplates">
						<i class="pi pi-check-circle"></i> {{ task.name }}
					</li>
				</ul>
			</div>

			<!-- CREATE YOUR OWN TASKS -->
			<div class="section custom-tasks">
				<div class="section-header">
					<span class="title">Create Your Own Tasks</span>
					<span class="badge manual">Manual Setup</span>
				</div>
				<p class="section-subtext">
					Start with zero tasks. Build your account from scratch with complete
					flexibility.
				</p>
				<p class="section-note">
					Note: This option does not include AI. Contact Support to add AI after
					your trial ends — setup fees may apply.
				</p>
			</div>

			<!-- BUTTONS -->
			<div class="button-row">
				<button
					pButton
					pRipple
					label="Use Pre-Configured Setup"
					class="p-button-raised p-button-primary w-fit"
					[loading]="isPreConfiguredLoading"
				[disabled]="isPreConfiguredLoading || isCustomSetupLoading"
				(click)="onOk()"
				></button>
				<button
					pButton
					pRipple
					label="Create My Own Tasks"
					class="p-button-outlined w-fit"
					[loading]="isCustomSetupLoading"
				[disabled]="isPreConfiguredLoading || isCustomSetupLoading"
				(click)="close()"
				></button>
			</div>
		</div>

		<!-- RIGHT SIDE IMAGE -->
		<div class="setup-right">
			<img
				src="assets/images/onboarding-celebration.png"
				alt="Onboarding Illustration"
				class="illustration"
			/>
		</div>
	</div>
</p-dialog>
